import { render } from "./MarkdownRenderer.vue?vue&type=template&id=3aff0286&scoped=true"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=js"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=js"

import "./MarkdownRenderer.vue?vue&type=style&index=0&id=3aff0286&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aff0286"]])

export default __exports__